import axios from 'axios';

document.addEventListener('DOMContentLoaded', function () {
	const form = document.getElementById('cursusForm');
	if (!form) return;

	const selectDropdown = document.querySelector('select[name="PaymentMethod"]');
	const bankgegevensField = document.querySelector('.bankDetails');

	const isMember = document.getElementById('member-yes');
	const isNoMember = document.getElementById('member-no');
	const memberInfo = document.querySelector('.memberInfo');

	const hasTeacher = document.getElementById('teacher-yes');
	const hasNoTeacher = document.getElementById('teacher-no');
	const teacherInfo = document.querySelector('.teacherInfo');

	const requiredInputsFields = document.querySelectorAll('.input:required');
	const requiredRadioSelectCheckboxFields = document.querySelectorAll(
		'.control:has(select:required), .control:has(.by-radio:required), .control:has(input[type="checkbox"]:required)'
	);

	const paymentMethodSelect = document.getElementById('paymentMethod');
	const submitButton = document.getElementById('inschrijfButton');

	const radios = document.querySelectorAll('.by-radio');

	let isSelectTouched = false;

	const addRequiredSign = (fields) => {
		fields.forEach(function (input) {
			const field = input.closest('.field');
			if (field) {
				const label = field.querySelector('label');
				if (label) {
					label.classList.add('is-required');
				}
			}
		});
	};

	const toggleFieldDisplay = (field, isRequired) => {
		field.style.display = isRequired ? 'block' : 'none';
		const inputField = field.querySelector('.input');
		if (isRequired) {
			inputField.setAttribute('required', '');
			inputField.setAttribute('data-validation', 'not-blank');
		} else {
			inputField.removeAttribute('required');
			inputField.removeAttribute('data-validation');
		}
	};

	const validateForm = () => {
		document
			.querySelectorAll('.field.radioValidation')
			.forEach(function (field) {
				checkFieldFilled(field);
			});
	};

	const checkFieldFilled = (field) => {
		const radios = field.querySelectorAll('.by-radio');
		const radioChecked = Array.from(radios).some((radio) => radio.checked);
		field.classList.toggle('is-empty', !radioChecked);
	};

	const updateSelectFieldValidation = (selectDropdown) => {
		const selectField = selectDropdown.closest('.field');
		if (
			!selectDropdown.value ||
			selectDropdown.value === selectDropdown.options[0].value
		) {
			selectField.classList.add('is-empty');
		} else {
			selectField.classList.remove('is-empty');
			selectField.classList.add('is-selected');
		}
	};

	const validateSelectFieldTouched = (selectDropdown, isTouched) => {
		if (!isTouched) {
			updateSelectFieldValidation(selectDropdown);
		}
	};

	const addCheckboxEventListeners = (selector) => {
		const checkboxes = document.querySelectorAll(selector);
		checkboxes.forEach((checkbox) =>
			checkbox.addEventListener('change', () => validateCheckbox(checkbox))
		);
	};

	const validateCheckbox = (checkbox) => {
		const field = checkbox.closest('.field');
		field.classList.toggle('is-empty', !checkbox.checked);
	};

	addRequiredSign(requiredInputsFields);
	addRequiredSign(requiredRadioSelectCheckboxFields);

	if (selectDropdown) {
		selectDropdown.addEventListener('change', function () {
			toggleFieldDisplay(
				bankgegevensField,
				this.value === 'Automatische incasso in één keer' ||
					this.value === 'Automatische incasso in termijnen'
			);
		});
	}

	if (isMember && isNoMember && memberInfo) {
		isMember.addEventListener('change', function () {
			toggleFieldDisplay(memberInfo, this.checked);
		});

		isNoMember.addEventListener('change', function () {
			toggleFieldDisplay(memberInfo, !this.checked);
		});
	}

	if (hasTeacher && hasNoTeacher && teacherInfo) {
		hasTeacher.addEventListener('change', function () {
			toggleFieldDisplay(teacherInfo, this.checked);
		});

		hasNoTeacher.addEventListener('change', function () {
			toggleFieldDisplay(teacherInfo, !this.checked);
		});
	}

	radios.forEach((radio) =>
		radio.addEventListener('change', function () {
			checkFieldFilled(this.closest('.field'));
		})
	);

	if (paymentMethodSelect) {
		paymentMethodSelect.addEventListener('change', function () {
			isSelectTouched = true;
			updateSelectFieldValidation(paymentMethodSelect);
		});

		if (submitButton) {
			submitButton.addEventListener('click', function () {
				validateSelectFieldTouched(paymentMethodSelect, isSelectTouched);
			});
		}
	}

	addCheckboxEventListeners('input[type="checkbox"][required]');
	addCheckboxEventListeners('input[type="checkbox"]');

	form.addEventListener('submit', (event) => {
		event.preventDefault();

		const requiredCheckboxes = document.querySelectorAll(
			'input[type="checkbox"][required]'
		);
		requiredCheckboxes.forEach((checkbox) => validateCheckbox(checkbox));

		validateForm();

		let object = {};
		const formData = new FormData(form);
		let finishPage;
		formData.forEach((value, key) => {
			if (key === 'FinishPage') {
				finishPage = value;
			}
			object[key] = value === 'true' ? true : value === 'false' ? false : value;
		});

		axios
			.post('/api/cursussen/aanmeldingen', JSON.stringify(object), {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(() => {
				if (finishPage) {
					window.location.href = finishPage;
				}
			})
			.catch((error) => {
				console.error('Error submitting form:', error);
			});
	});
});
